import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { BaseClass } from '../../utility/baseClass';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Entityservice } from '../../main-layout/entity/entityservice';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-entitymodal',
  templateUrl: './entitymodal.component.html',
  styleUrls: ['./entitymodal.component.css']
})
export class EntitymodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  countyList = [];
  hubList = [];
  typelist = [];
  regionList = [];
  cityList = [];
  locationtype = [];
  saveTitle = 'Add';
  requestform: FormGroup;
  onlyView: any;
  isEdit: boolean = false;
  activeFlag = [
    { 'labelname': 'Active', 'value': 'Y' },
    { 'labelname': 'Inactive', 'value': 'N' }
  ];
  sendmaillist = [
    { 'labelname': 'YES', 'value': 'Y' },
    { 'labelname': 'NO', 'value': 'N' }
  ];
  inoperativelist = [
    { 'labelname': 'YES', 'value': 'Y' },
    { 'labelname': 'NO', 'value': 'N' }
  ];
  cinExists: String = ""
  isCinRequired: String = "";
  orgType: String = "";
  orgId: String = "";
  userRole: String = "";
  existingdetails: any = {};
  groupList = [];
  extraDetails: { noOfCompany?: number; currentNumberOfCompany?: number;limitedAccess?: String;[key: string]: any } = {};
  public validation_message = {
    entityname: [
      { type: 'required', message: 'Entity Name is required.' },
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
    ],
    entityinitial: [
      { type: 'required', message: 'Entity initial is required.' },
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
    ],
    cinnumber: [
      { type: 'required', message: 'CIN number is required.' },
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
    entitytype: [{ type: 'required', message: 'Entity type is required.' }],
    entityaddress: [
      { type: 'SPACESTRICTFORINITIALVALIDATION', message: 'Space is not allowed at the beginning.' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
    ],
    activeflag: [{ type: '', message: '' }],
    group: [{ type: 'required', message: 'group type is required.' }],


  }
  tempentity: any;
  currentNumberOfCompany: number;
  noOfCompany: number;
  previousActiveFLag: String;
  previousInOperativeFlag: String;
  isLegalNameChanged: number;
  limitedAccess: String = "N";

  constructor(
    private entityService: Entityservice,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice,
    private spinnerservice: NgxSpinnerService,
    private el: ElementRef
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.orgType = dataFromParent.orgType;
    this.orgId = dataFromParent.orgId;
    this.userRole = dataFromParent.userRole;
    this.onlyView = dataFromParent?.onlyView || false;
    this.extraDetails = dataFromParent?.extraDetails || {};
    this.noOfCompany = this.extraDetails.noOfCompany;
    this.currentNumberOfCompany = this.extraDetails.currentNumberOfCompany;
    this.previousActiveFLag = dataFromParent.datas[0]?.activeflag;
    this.previousInOperativeFlag = dataFromParent.datas[0]?.inoperative;
    this.isLegalNameChanged = dataFromParent.datas[0]?.isLegalNameChanged;
    this.gettoken();
    if (dataFromParent?.title === 'Modify Entity') {
      this.isEdit = true;
      this.saveTitle = 'Modify';
      this.existingdetails = dataFromParent.datas;
      this.limitedAccess = this.extraDetails.limitedAccess;
    } 
  }

  updateCINValidator(entityTypeId: number) {
    const cinnumberControl = this.requestform.get('cinnumber');

    if ([1, 2, 3].includes(entityTypeId)) { // IDs for Private/Public/Listed
      this.isCinRequired = "Y";
      cinnumberControl?.setValidators([
        Validators.required,
        Validators.maxLength(23),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      ]);
    } else {
      this.isCinRequired = "N";
      cinnumberControl?.setValidators([
        Validators.maxLength(23),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      ]);
    }

    cinnumberControl?.updateValueAndValidity();
  }


  ngOnInit() {
    this.formInitiliaze();
    this.getEntityType();

    this.requestform.get('entitytype')?.valueChanges.subscribe((type) => {
      this.updateCINValidator(type);
    });

    if (this.orgType == "P" || this.orgId == "0") {
      this.getGroup();
    }

    // if (this.isLegalNameChanged === 1) {
    //     this.requestform.get('activeflag')?.disable();
    //     this.requestform.get('inoperative')?.disable();

    //   }


    if (this.isEdit || this.onlyView) {
      const data = this.config.data?.datas?.[0];
      setTimeout(() => {
        this.patchValueForms(data);
        if (this.onlyView) {
          this.requestform.disable();
        }
      }, 300);
    }
  }

  patchValueForms(data) {
    this.requestform.patchValue({
      'entityname': data?.companyname,
      'entityinitial': data?.companyinitial,
      'sendmail': data?.sendmail,
      'cinnumber': data?.cinnumber,
      'inoperative': data?.inoperative,
      'entitytype': data?.companytype,
      'activeflag': data?.activeflag,
      'group': data?.groupid,
      'entityaddress': data?.address,
      'oldName': data?.oldName,
      'effectiveDateForChange': data?.effectiveDateForChange
    });
  }

  dismiss() {
    Swal.fire({
      title: "Are you sure you want to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }

  formInitiliaze() {
    this.requestform = this.fb.group({
      entityname: ['', Validators.compose([Validators.required,
      Validators.maxLength(100),
      Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
      Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)

      ])],
      entityinitial: ['', Validators.compose([Validators.required,
      Validators.maxLength(20),
      Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
      Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
      sendmail: ['N', Validators.compose([Validators.required])],
      cinnumber: ['', Validators.compose([Validators.required,
      Validators.maxLength(23),
      Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
      Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      ])],
      inoperative: ['N', Validators.compose([Validators.required])],
      entitytype: ['', Validators.compose([Validators.required])],
      entityaddress: ['', Validators.compose([
        Validators.maxLength(1000),
        Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
      activeflag: ['Y'],
      group: [''],
      oldName: [{ value: '', disabled: this.onlyView }],
      effectiveDateForChange: [{ value: '', disabled: this.onlyView }]
    });
    if (this.isEdit) {
      this.requestform.setValidators(this.activeInoperativeValidator);
    }
    if (this.orgType !== 'P' && this.orgId !== '0') {
      this.requestform.get('group')?.disable();
    }

    // if (this.orgType === 'P' || this.orgId == "0") {
    //   this.requestform.addControl(
    //     'group',
    //     this.fb.control('', Validators.required)
    //   );
    // }
  }

  // add() {
  //   if (this.requestform.invalid) {
  //     this.validateAllFormFields(this.requestform, this.el);
  //     return;
  //   }
  //   else if (this.saveTitle === 'Modify') {
  //     this.modify(this.requestform.value);
  //   } else {
  //     Swal.fire({
  //       title: "Do you want to Save the Changes?",
  //       showDenyButton: true,
  //       showCancelButton: true,
  //       confirmButtonText: "Save",
  //       denyButtonText: `Don't Save`
  //     }).then((value) => {
  //       if (value.isConfirmed) {
  //         let data = this.requestform.value;
  //         data['csrftoken'] = this.CSRFToken
  //         this.entityService.post(this.requestform.value).subscribe((data) => {
  //           this.tempentity = data;
  //           console.log(this.tempentity, 'line 131')
  //           if (this.tempentity.response == 'Exists') {
  //             Swal.fire("Entity name already exists", " ", "error").then(result => {
  //               this.ref.close()
  //             });
  //           } else {
  //             Swal.fire("Saved!", "", "success").then(result => {
  //               this.ref.close('Save');
  //             });
  //           }
  //         }, error => {
  //           Swal.fire({
  //             icon: "error",
  //             title: error.error.error,
  //             footer: "Error status is: " + error.status
  //           });
  //         });
  //       } else if (value.isDenied) {
  //         Swal.fire("Changes are not saved", "", "info");
  //       }
  //     });

  //   }
  // }

  // modify(data: any) {

  //   Swal.fire({
  //     title: "Do you want to Save the Changes?",
  //     showDenyButton: true,
  //     showCancelButton: true,
  //     confirmButtonText: "Save",
  //     denyButtonText: `Don't Save`
  //   }).then((value) => {
  //     if (value.isConfirmed) {
  //       let data = this.requestform.value;
  //       data['csrftoken'] = this.CSRFToken
  //       data.activeflag = this.requestform.get('activeflag').value;
  //       data.companyid = this.existingdetails[0].companyid;

  //       // commented to check existing
  //       // this.entityService.modify(data).subscribe({
  //       //   next: (response: any) => {

  //       //     if (response?.response === 'exists') {
  //       //       Swal.fire("Entity Name  exists!", "", "error");
  //       //     } else {
  //       //       Swal.fire("Entity added successfully!", "", "success").then(() => {
  //       //         this.ref.close();
  //       //       });
  //       //     }
  //       //   },
  //       //   error: (error) => {
  //       //     Swal.fire({
  //       //       icon: "error",
  //       //       title: "Oops...",
  //       //       text: error.error?.error || "An unexpected error occurred.",
  //       //       footer: `Error status is: ${error.status}`
  //       //     });
  //       //   }
  //       // });
  //     } else if (value.isDenied) {
  //       Swal.fire("Changes are not saved", "", "info");
  //     }
  //   });
  // }


  add() {
    if (this.requestform.invalid) {
      this.validateAllFormFields(this.requestform, this.el);
      return;
    }
    else if (this.saveTitle === 'Modify') {
      this.modify(this.requestform.value);
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          let data = this.requestform.value;
          if (this.noOfCompany <= this.currentNumberOfCompany && data.inoperative == "N") {
            Swal.fire("Maximum Allowed Entities Used as Operative", "Please Contact Complinity Helpdesk", "error").then(result => {
              this.ref.close()
            });
            return;
          }
          data['csrftoken'] = this.CSRFToken
          const payload = { cinNumber: data.cinnumber, companyId: data.companyid };

          if (this.isCinRequired == "Y") {
            this.entityService.checkDuplicateCinInModify(payload).subscribe({
              next: (result: any) => {
                let companies = Object.values(result[0])[0];
                if (companies == "nocomplinitydatafound") {
                  this.entityService.post(this.requestform.value).subscribe((data) => {
                    this.tempentity = data;
                    if (this.tempentity.response == 'exists') {
                      Swal.fire("Entity Name or Initial or CIN/Regn. No already exists!", " ", "error").then(result => {
                        this.ref.close()
                      });
                    } else {
                      Swal.fire("Entity added successfully!", "", "success").then(result => {
                        this.ref.close('Save');
                      });
                    }
                  }, error => {

                    if (error.error.response == 'html') {
                      Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                      })
                    }       
              else{ 
                    Swal.fire({
                      icon: "error",
                      title: error.error.error,
                      footer: "Error status is: " + error.status
                    });}
                  });

                }
                else {
                  Swal.fire({
                    title: "Entity or Entities with the same CIN number is already existing, Are you sure you want to create another Entity with the same CIN Number?",
                    text: `Entities: ${companies}`,
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "Cancel"
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.entityService.post(this.requestform.value).subscribe((data) => {
                        this.tempentity = data;
                        if (this.tempentity.response == 'exists') {
                          Swal.fire("Entity Name or Initial or CIN/Regn. No already exists!", " ", "error").then(result => {
                            this.ref.close(); 
                          });
                        } else {
                          Swal.fire("Entity added successfully!", "", "success").then(result => {
                            this.ref.close('Save');
                          });
                        }
                      }, error => {
                        Swal.fire({
                          icon: "error",
                          title: error.error.error,
                          footer: "Error status is: " + error.status
                        });
                      });
                    } else if (result.isDismissed) {
                      Swal.fire("Changes are not saved", "", "info");
                      this.ref.close();  
                    }
                  });
                }
              },
              error: (err) => {
                Swal.fire("Error checking CIN", err.error?.error || "An unexpected error occurred", "error");
              }
            });
          }
          else {
            this.entityService.post(this.requestform.value).subscribe((data) => {
              this.tempentity = data;
              if (this.tempentity.response == 'exists') {
                Swal.fire("Entity Name or Initial or CIN/Regn. No already exists!", " ", "error").then(result => {
                  this.ref.close();  
                });
              } else {
                Swal.fire("Entity added successfully!", "", "success").then(result => {
                  this.ref.close('Save');
                });
              }
            }, error => {
              Swal.fire({
                icon: "error",
                title: error.error.error,
                footer: "Error status is: " + error.status
              });
            });
          }


        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();  

        }
      });

    }
  }


  modify(data: any) { 
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    }).then((value) => {
      if (value.isConfirmed) {
        let data = this.requestform.value;

        data['csrftoken'] = this.CSRFToken;
        data.activeflag = this.requestform.get('activeflag').value;  
        data.companyid = this.existingdetails[0].companyid; 
        if (this.currentNumberOfCompany >= this.noOfCompany){
          
          // if ( this.requestform.get('activeflag').value == "Y") {
          //   Swal.fire("Maximum Allowed Entities Used as Operative", "Please Contact Complinity Helpdesk", "error").then(result => {
          //     this.ref.close()
          //   });
          //   return;
          // }
          if ((this.previousActiveFLag == "N" && this.requestform.get('activeflag').value == "Y") || this.previousInOperativeFlag == "Y" && data.inoperative == "N") {
            Swal.fire("Maximum Allowed Entities Used as Operative", "Please Contact Complinity Helpdesk", "error").then(result => {
              this.ref.close()
            });
            return;
          }
        }
        const payload = { cinNumber: data.cinnumber, companyId: data.companyid };
        if (this.isCinRequired == "Y") {
          this.entityService.checkDuplicateCinInModify(payload).subscribe({
            next: (result: any) => {
              let companies = Object.values(result[0])[0];
              if (companies == "nocomplinitydatafound") {
                this.entityService.modify(data).subscribe({
                  next: (response: any) => {
                    if (response?.response === 'exists') {
                      Swal.fire("Entity Name or Initial or CIN/Regn. No already exists!", "", "error");
                    } else {
                      Swal.fire("Entity modified successfully!", "", "success").then(() => {
                        this.ref.close();
                      });
                    }
                  },
                  error: (error) => {
                                if (error.error.response == 'html') {
                                    Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                    })
                                  }       
                              else{   
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: error.error?.error || "An unexpected error occurred.",
                      footer: `Error status is: ${error.status}`
                    });
                  }
                  }
                });
              }
              else { // check cin
                Swal.fire({
                  title: "Entity or Entities with the same CIN number is already existing, Are you sure you want to modify this Entity with Same CIN Number?",
                  text: `Entities: ${companies}`,
                  icon: "info",
                  showCancelButton: true,
                  confirmButtonText: "Yes",
                  cancelButtonText: "Cancel"
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.entityService.modify(data).subscribe({
                      next: (response: any) => {
                        if (response?.response === 'exists') {
                          Swal.fire("Entity Name or Initial or CIN/Regn. No already exists!", "", "error");
                        } else {
                          Swal.fire("Entity modified successfully!", "", "success").then(() => {
                            this.ref.close();
                          });
                        }
                      },
                      error: (error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: error.error?.error || "An unexpected error occurred.",
                          footer: `Error status is: ${error.status}`
                        });
                      }
                    });
                  }
                  else if (value.isDenied) {
                    Swal.fire("Changes are not saved", "", "info");
                    this.ref.close();  

                  }
                });
              }
            },
            error: (err) => {
              Swal.fire("Error checking CIN", err.error?.error || "An unexpected error occurred", "error");
            }
          });
        }
        else { 
          this.entityService.modify(data).subscribe({
            next: (response: any) => {
              if (response?.response === 'exists') {
                Swal.fire("Entity Name or Initial or CIN/Regn. No already exists!", "", "error");
              } else {
                Swal.fire("Entity modified successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.error?.error || "An unexpected error occurred.",
                footer: `Error status is: ${error.status}`
              });
            }
          });
        }

      }


      else if (value.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
        this.ref.close();  

      }
    });
  }


  getEntityType() {
    this.entityService.getentitytypeList().subscribe(res => {
      this.typelist = res;
      this.typelist.unshift({ id: '', companytype: 'Select' });
    });
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  getDynamicClasses(isEdit) {
    if (isEdit) {
      return 'col-12 md:col-4 lg:col-4';
    }
    else {
      return 'col-12 md:col-6 lg:col-6';
    }
  }

  getGroup() {
    this.entityService.getGroup().subscribe(res => {
      this.groupList = res;
      this.groupList.unshift({ groupid: '', groupname: 'Select' });
    });
  }

  activeInoperativeValidator(formGroup: FormGroup) {
    const activeflag = formGroup.get('activeflag')?.value;
    const inoperative = formGroup.get('inoperative')?.value;

    if (activeflag === 'Y' && inoperative === 'Y') {
      formGroup.get('inoperative')?.setErrors({ inoperativeConflict: true });
    } else {
      if (formGroup.get('inoperative')?.hasError('inoperativeConflict')) {
        formGroup.get('inoperative')?.setErrors(null);
      }
    }

    return null;
  }


}
